<template>
  <material-card>
    <v-layout px-3 slot="header">
      <v-flex mt-2 pl-3 align-center justify-center>
        <div class="headline">Karty klienta</div>

        <p>Karty przypisane do klienta</p>
      </v-flex>
    </v-layout>

    <v-layout row justify-center>
      <v-flex xs12 md10 lg8>
        <v-layout row wrap>
          <v-spacer></v-spacer>

          <check-permission permissions="CARD.ADD">
            <v-btn @click="showCardModal" color="primary"> <v-icon left>mdi-plus</v-icon>Dodaj </v-btn>
          </check-permission>
        </v-layout>

        <div v-if="cards.length > 0">
          <v-card v-for="(card, index) in cards" :key="index" class="ma-2">
            <v-card-text style="position: relative;">
              <v-layout row wrap>
                <v-flex xs11>
                  <v-layout row wrap>
                    <v-flex xs12 md6>
                      <p><b>Numer karty:</b> {{ card.number ? card.number : 'Brak' }}</p>

                      <p v-if="card.accepted"><b>Data wydania karty:</b> {{ card.accepted | moment('DD-MM-YYYY') }}</p>
                    </v-flex>

                    <v-flex xs12 md6>
                      <p><b>Status:</b> {{ card.state | state }}</p>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs1>
                  <check-permission permissions="CARD.UPDATE">
                    <v-btn flat small icon color="primary" @click="editCard(card.id)">
                      <v-icon>mdi-pencil-outline</v-icon>
                    </v-btn>
                  </check-permission>

                  <check-permission v-if="CardState.INACTIVE != CardState[card.state]" permissions="CARD.DELETE">
                    <v-btn flat small icon color="error" @click="confirmRemove(card.id, card.number)">
                      <v-icon>mdi-cancel</v-icon>
                    </v-btn>
                  </check-permission>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </div>
      </v-flex>
    </v-layout>

    <material-dialog
      title="Potwierdź zablokowanie karty"
      cancelText="Anuluj"
      confirmText="Zablokuj kartę"
      header-color="white--text error darken-1"
      :width="400"
      :show="confirmDialog"
      :text="`Zablokowanie  karty o numerze ${remove.cardNumber}`"
      :id="remove.id"
      @close="hideDialog"
      @confirm="removeCard"
    ></material-dialog>

    <card-modal :id="edit.id" :show="cardModal" :profileId="id" @close="hideCardModal"></card-modal>
  </material-card>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
import { CardState, CardStateTranslation } from '@witkac/kartamiejska-shared';

import MaterialCard from '@/components/material/Card';
import CardModal from '../modals/Card.modal';
import MaterialDialog from '@/components/material/Dialog';

// @vuese
// Wyświetlanie zakładki kart klienta
// @group Client-Profile
export default {
  components: { CardModal, MaterialDialog, MaterialCard },

  data() {
    return {
      cardModal: false,
      confirmDialog: false,
      remove: {
        id: undefined,
        cardNumber: undefined
      },
      edit: { id: undefined },
      CardState
    };
  },
  methods: {
    // @vuese
    // funkcja wywołuje pobranie listy kart klienta do store
    getCards() {
      this.$store.dispatch('client/cards/list');
    },
    // @vuese
    // funkcja wywołuje modal edycji / dodawania karty
    showCardModal() {
      this.cardModal = true;
    },
    // @vuese
    // funkcja ukrywa modal edycji / dodawania karty
    hideCardModal() {
      this.cardModal = !true;
      this.edit.id = undefined;
    },
    // @vuese
    // funkcja ustawia dane do potwierdzenia
    confirmRemove(id, cardNumber) {
      this.remove.id = id;
      this.remove.cardNumber = cardNumber || 'brak numeru';
      this.showDialog();
    },
    // @vuese
    // funkcja ukrywa modal potwierdzenia usunięcia karty
    hideDialog() {
      this.confirmDialog = false;
      this.remove.id = undefined;
      this.remove.cardNumber = undefined;
    },
    // @vuese
    // funkcja wywołuje modal potwierdzenia usunięcia karty
    showDialog() {
      this.confirmDialog = true;
    },
    // @vuese
    // funkcja wywołuje usunięcie karty klienta poprzez store
    // @arg `id` - ID karty do usunięcia
    async removeCard(id) {
      try {
        this.$store.dispatch('client/cards/block', id);
      } catch (error) {
        console.warn(error);
      }
    },
    // @vuese
    // funkcja wywołuje modal edycji karty
    // @arg `id` - ID karty do edycji
    editCard(id) {
      this.edit.id = id;
      this.cardModal = true;
    }
  },
  computed: mapState({
    cards: state => state.client.cards.list,
    id: state => state.client.data.profile.id
  }),
  watch: {
    modalClose(val) {
      if (val) {
        this.hideCardModal();
      }
    },
    '$store.state.modalClose.confirm'(val) {
      if (val) {
        this.$store.dispatch('resetConfirmState');
      } else {
        this.hideCardModal();
      }
    }
  },
  mounted() {
    this.getCards();
  },
  filters: {
    state(value) {
      return CardStateTranslation[CardState[value]];
    }
  }
};
</script>
